// extracted by mini-css-extract-plugin
export default {"root":"Aside_root__Kd1OQ","wrapper":"Aside_wrapper__QNAjm"};